{
  "#PASSWORD": {
    "TITLE": "Forgot Password?",
    "COMPONENTS": {
      "USER_FORM": {
        "TITLE": "Forgot Password",
        "STEP1": "Step 1/2: Request Confirmation Code",
        "USERNAME": "Username",
        "EMAIL": "Email Address",
        "INFO": "Click 'Request Confirmation Code' to receive an email at the provided address (if it is linked to the specified user account). Click the link in the email to continue resetting your password.",
        "SUBMIT": "Request Confirmation Code"
      },
      "RESET_FORM": {
        "TITLE": "Forgot Password",
        "STEP2": "Step 2/2: Reset Password",
        "TOKEN": "Confirmation Code",
        "PASSWORD": "New Password",
        "USERNAME": "Username: ",
        "PASSWORD_REPEAT": "Repeat New Password",
        "SUBMIT": "Change Password"
      }
    },
    "MESSAGES": {
      "CONFIRMATION_SENT": "A message with the confirmation code has been sent to the provided email address.",
      "RESET_SUCCESS": "Your password was successfully reset",
      "RESET_FAILURE": "Your password could not be reset",
      "CONFIRMATION_FAILED": "The confirmation code could not be sent"
    },
    "VALIDATION": {
      "PASSWORD": {
        "MIN_LENGTH": "Must be at least {{requiredLength}} characters long",
        "MIN_LENGTH_MESSAGE": "Currently: {{actualLength}}",
        "UPPERCASE": "Must contain at least one uppercase letter",
        "LOWERCASE": "Must contain at least one lowercase letter",
        "NUMBER": "Must contain at least one number",
        "SYMBOL": "Must contain at least one special character",
        "OPTIONAL": "(optional)"
      },
      "PASSWORD_REPEAT": {
        "UNEQUAL": "Passwords do not match!"
      }
    },
    "SETTINGS": {
      "TITLE": "Change Password",
      "STEP1": "Step 1: Request Confirmation Code",
      "STEP2": "Step 2: Change Password",
      "EMAIL": "Email Address",
      "TOKEN": "Confirmation Code",
      "PASSWORD": "New Password",
      "PASSWORD_REPEAT": "Repeat New Password",
      "SEND_TOKEN": "Request Confirmation Code",
      "CHANGE_PASSWORD": "Change Password"
    }
  }
}
